import { ReactNode } from "react";

/* Prop Types */
interface ToolbarProps {
  children: ReactNode;
}

/*
 * Toolbar component
 */
export const Toolbar = ({ children }: ToolbarProps) => {
  /* Render */
  return <div className="flex flex-row justify-between min-h-10 h-10 max-h-10">{children}</div>;
};
